module.exports = __webpack_public_path__ + "img/dashboard_active.b5f15812.svg";